import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './module-link.styl'
import { Link } from 'react-router-dom'

export default class ModuleLink extends Component {
  static propTypes = {
    to: PropTypes.object,
    text: PropTypes.object
  }

  render () {
    const { to, text } = this.props

    return (
      <Link className={`${styles.link} ${styles.isClickable}`} to={to}>
        {text}
      </Link>)
  }
}
